import { analyticsJourneyCards } from '../data/analytics-journey'
import { Link } from 'react-router'

export const AnalyticsJourney = () => {
  return (
    <section className="page-section page-section--lg section-spacing analytics-journey">
      <div className="page-section__inner analytics-journey__inner">
        <hgroup className="analytics-journey__header">
          <h2 className="heading-xl text-brand-dark">
            Accelerate your AI &amp; analytics journey
          </h2>
        </hgroup>

        <div className="analytics-journey__grid">
          {analyticsJourneyCards.map(
            ({
              audience,
              body,
              href,
              logoAlt,
              logoClassName,
              logoSrc,
              quote,
              tone,
            }) => (
              <article
                className="analytics-journey-card"
                data-tone={tone}
                key={audience}
              >
                <div className="analytics-journey-card__media">
                  <img
                    alt={logoAlt}
                    className={logoClassName}
                    loading="lazy"
                    src={logoSrc}
                  />
                </div>

                <blockquote className="analytics-journey-card__quote body-m text-brand-dark">
                  {quote}
                </blockquote>

                <div className="analytics-journey-card__copy">
                  <h3 className="heading-s">
                    <Link to={href}>
                      {audience}
                      <span aria-hidden="true">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="19.2391"
                            height="19.2391"
                            rx="9.61957"
                            fill="#FF5FA2"
                          />
                          <path
                            d="M8.28223 6.12549L11.6412 9.48438L8.28223 12.8434"
                            stroke="white"
                            strokeWidth="1.14258"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                    </Link>
                  </h3>
                  <p className="body-m text-primary">{body}</p>
                </div>
              </article>
            ),
          )}
        </div>
      </div>
    </section>
  )
}
